import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import { assertEqualsBestellliste, resetArrangement } from "./utils";
import { BestelllistenEintrag } from "../arrangement/Stückliste";
import type { Arrangement } from "../arrangement/Arrangement";

export default {
  name: "TestTorpfostenSets",
};

const assertBestellisteContainsArtikelnummer = (
  artikelnummer: string,
  bestelliste: BestelllistenEintrag[],
  message = ""
) => {
  return assert.isNotNull(
    bestelliste.find((b) => b.Artikelnummer == artikelnummer),
    "No matching artikel found: " + artikelnummer
  );
};

const setArtikelnummer = {
  dreifachtor180: "2625",
  dreifachtorSonderhöhe: "2626",
  doppeltor180: "2018",
  doppeltor90: "732",
  doppeltorSonderhöhe: "2624",
  einzeltor180: "2059",
  einzeltor90: "731",
  einzeltorSonderhöhe: "2623",
};

export const testEinfachtor185: Test = async () => {
  const { agt } = await createElementEinzeltorElementArrangement();
  assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor180, agt.bestellliste);
};

export const testEinfachtor90: Test = async () => {
  const { agt } = await createElementEinzeltorElementArrangement();
  setHeights(agt, [0.95, 0.9, 0.95]);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor90, agt.bestellliste);
};

export const testEinfachtor150: Test = async () => {
  const { agt, segment } = await createElementEinzeltorElementArrangement();
  setHeights(agt, [1.55, 1.5, 1.55]);
  console.log(agt, agt.bestellliste);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
};

export const testEinfachtorSeitenKleiner: Test = async () => {
  const { agt, segment } = await createElementEinzeltorElementArrangement();
  await subTestContext("links kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor180, agt.bestellliste);
  });
  await subTestContext("rechts kleiner", () => {
    setHeights(agt, [1.85, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor180, agt.bestellliste);
  });
  await subTestContext("beide kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor180, agt.bestellliste);
  });
  await subTestContext("links kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor90, agt.bestellliste);
  });
  await subTestContext("rechts kleiner, Gartentor", () => {
    setHeights(agt, [0.95, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor90, agt.bestellliste);
  });
  await subTestContext("beide kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltor90, agt.bestellliste);
  });
};

export const testEinfachtorSeitenGrößer: Test = async () => {
  const { agt, segment } = await createElementEinzeltorElementArrangement();
  await subTestContext("beide größer, Sonderhöhe [1.85, 1.5, 1.85]", () => {
    setHeights(agt, [1.85, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.85]", () => {
    setHeights(agt, [1.85, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.55, 0.9, 1.85]", () => {
    setHeights(agt, [1.55, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.55]", () => {
    setHeights(agt, [1.85, 0.9, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });

  await subTestContext("Standardhöhe, Sonderhöhe, Sonderhöhe [1.85, 1.5, 1.55]", () => {
    setHeights(agt, [1.85, 1.5, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Sonderhöhe, Gartentor [1.85, 1.5, 0.95]", () => {
    setHeights(agt, [1.85, 1.5, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Sonderhöhe, XS [1.85, 1.5, 0.8]", () => {
    setHeights(agt, [1.85, 1.5, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Sonderhöhe, Sonderhöhe, Standardhöhe [1.55, 1.5, 1.85]", () => {
    setHeights(agt, [1.55, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Gartentor, Sonderhöhe, Standardhöhe [0.95, 1.5, 1.85]", () => {
    setHeights(agt, [0.95, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("XS, Sonderhöhe, Standardhöhe [0.8, 1.5, 1.85]", () => {
    setHeights(agt, [0.8, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });

  await subTestContext("Standardhöhe, Gartentor, Gartentor [1.85, 0.9, 0.95]", () => {
    setHeights(agt, [1.85, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Gartentor, XS [1.85, 0.9, 0.8]", () => {
    setHeights(agt, [1.85, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Gartentor, Gartentor, Standardhöhe [0.95, 0.9, 1.85]", () => {
    setHeights(agt, [0.95, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("XS, Gartentor, Standardhöhe [0.8, 0.9, 1.85]", () => {
    setHeights(agt, [0.8, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.einzeltorSonderhöhe, agt.bestellliste);
  });
};

export const testDoppeltor185: Test = async () => {
  const { agt } = await createElementDoppeltorElementArrangement();
  assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor180, agt.bestellliste);
};

export const testDoppeltor90: Test = async () => {
  const { agt } = await createElementDoppeltorElementArrangement();
  setHeights(agt, [0.95, 0.9, 0.95]);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor90, agt.bestellliste);
};

export const testDoppeltor150: Test = async () => {
  const { agt, segment } = await createElementDoppeltorElementArrangement();
  setHeights(agt, [1.55, 1.5, 1.55]);
  console.log(agt, agt.bestellliste);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
};

export const testDoppeltorSeitenKleiner: Test = async () => {
  const { agt, segment } = await createElementDoppeltorElementArrangement();
  await subTestContext("links kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor180, agt.bestellliste);
  });
  await subTestContext("rechts kleiner", () => {
    setHeights(agt, [1.85, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor180, agt.bestellliste);
  });
  await subTestContext("beide kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor180, agt.bestellliste);
  });
  await subTestContext("links kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor90, agt.bestellliste);
  });
  await subTestContext("rechts kleiner, Gartentor", () => {
    setHeights(agt, [0.95, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor90, agt.bestellliste);
  });
  await subTestContext("beide kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltor90, agt.bestellliste);
  });
};

export const testDoppeltorSeitenGrößer: Test = async () => {
  const { agt, segment } = await createElementDoppeltorElementArrangement();
  await subTestContext("beide größer, Sonderhöhe [1.85, 1.5, 1.85]", () => {
    setHeights(agt, [1.85, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.85]", () => {
    setHeights(agt, [1.85, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.55, 0.9, 1.85]", () => {
    setHeights(agt, [1.55, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.55]", () => {
    setHeights(agt, [1.85, 0.9, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });

  await subTestContext("Standardhöhe, Sonderhöhe, Sonderhöhe [1.85, 1.5, 1.55]", () => {
    setHeights(agt, [1.85, 1.5, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Sonderhöhe, Gartentor [1.85, 1.5, 0.95]", () => {
    setHeights(agt, [1.85, 1.5, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Sonderhöhe, XS [1.85, 1.5, 0.8]", () => {
    setHeights(agt, [1.85, 1.5, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Sonderhöhe, Sonderhöhe, Standardhöhe [1.55, 1.5, 1.85]", () => {
    setHeights(agt, [1.55, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Gartentor, Sonderhöhe, Standardhöhe [0.95, 1.5, 1.85]", () => {
    setHeights(agt, [0.95, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("XS, Sonderhöhe, Standardhöhe [0.8, 1.5, 1.85]", () => {
    setHeights(agt, [0.8, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });

  await subTestContext("Standardhöhe, Gartentor, Gartentor [1.85, 0.9, 0.95]", () => {
    setHeights(agt, [1.85, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Standardhöhe, Gartentor, XS [1.85, 0.9, 0.8]", () => {
    setHeights(agt, [1.85, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("Gartentor, Gartentor, Standardhöhe [0.95, 0.9, 1.85]", () => {
    setHeights(agt, [0.95, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
  await subTestContext("XS, Gartentor, Standardhöhe [0.8, 0.9, 1.85]", () => {
    setHeights(agt, [0.8, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.doppeltorSonderhöhe, agt.bestellliste);
  });
};
export const testDreifachtor185: Test = async () => {
  const { agt } = await createElementDreifachtorElementArrangement();
  assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtor180, agt.bestellliste);
};

export const testDreifachtor150: Test = async () => {
  const { agt } = await createElementDreifachtorElementArrangement();
  setHeights(agt, [1.55, 1.5, 1.5, 1.55]);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtorSonderhöhe, agt.bestellliste);
};

export const testDreifachtor90: Test = async () => {
  const { agt } = await createElementDreifachtorElementArrangement();
  setHeights(agt, [0.95, 0.9, 0.9, 0.95]);
  assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtorSonderhöhe, agt.bestellliste);
};

export const testDreifachtorSeitenKleiner: Test = async () => {
  const { agt, segment } = await createElementDreifachtorElementArrangement();
  await subTestContext("links kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.8, 1.85]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtor180, agt.bestellliste);
  });
  await subTestContext("rechts kleiner", () => {
    setHeights(agt, [1.85, 1.8, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtor180, agt.bestellliste);
  });
  await subTestContext("beide kleiner", () => {
    setHeights(agt, [1.55, 1.8, 1.8, 1.55]);
    assertBestellisteContainsArtikelnummer(setArtikelnummer.dreifachtor180, agt.bestellliste);
  });
  await subTestContext("links kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("rechts kleiner, Gartentor", () => {
    setHeights(agt, [0.95, 0.9, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("beide kleiner, Gartentor", () => {
    setHeights(agt, [0.8, 0.9, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
};

export const testDreifachtorSeitenGrößer: Test = async () => {
  const { agt, segment } = await createElementDreifachtorElementArrangement();
  await subTestContext("beide größer, Sonderhöhe [1.85, 1.5, 1.85]", () => {
    setHeights(agt, [1.85, 1.5, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.85]", () => {
    setHeights(agt, [1.85, 0.9, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("beide größer, Gartentor [1.55, 0.9, 1.85]", () => {
    setHeights(agt, [1.55, 0.9, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("beide größer, Gartentor [1.85, 0.9, 1.55]", () => {
    setHeights(agt, [1.85, 0.9, 0.9, 1.55]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });

  await subTestContext("Standardhöhe, Sonderhöhe, Sonderhöhe [1.85, 1.5, 1.55]", () => {
    setHeights(agt, [1.85, 1.5, 1.5, 1.55]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Standardhöhe, Sonderhöhe, Gartentor [1.85, 1.5, 0.95]", () => {
    setHeights(agt, [1.85, 1.5, 1.5, 0.95]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Standardhöhe, Sonderhöhe, XS [1.85, 1.5, 0.8]", () => {
    setHeights(agt, [1.85, 1.5, 1.5, 0.8]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Sonderhöhe, Sonderhöhe, Standardhöhe [1.55, 1.5, 1.85]", () => {
    setHeights(agt, [1.55, 1.5, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Gartentor, Sonderhöhe, Standardhöhe [0.95, 1.5, 1.85]", () => {
    setHeights(agt, [0.95, 1.5, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("XS, Sonderhöhe, Standardhöhe [0.8, 1.5, 1.85]", () => {
    setHeights(agt, [0.8, 1.5, 1.5, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });

  await subTestContext("Standardhöhe, Gartentor, Gartentor [1.85, 0.9, 0.95]", () => {
    setHeights(agt, [1.85, 0.9, 0.9, 0.95]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Standardhöhe, Gartentor, XS [1.85, 0.9, 0.8]", () => {
    setHeights(agt, [1.85, 0.9, 0.9, 0.8]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("Gartentor, Gartentor, Standardhöhe [0.95, 0.9, 1.85]", () => {
    setHeights(agt, [0.95, 0.9, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("XS, Gartentor, Standardhöhe [0.8, 0.9, 1.85]", () => {
    setHeights(agt, [0.8, 0.9, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
};

export const testDreifachtorHöheInTor = async () => {
  const { agt, segment } = await createElementDreifachtorElementArrangement();
  await subTestContext("diagonal hoch, zwischen hohen", () => {
    setHeights(agt, [1.85, 1.5, 1.8, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("diagonal hoch, zwischen tiefen", () => {
    setHeights(agt, [0.9, 1.5, 1.8, 0.9]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("diagonal runter, zwischen tiefen", () => {
    setHeights(agt, [0.9, 1.8, 0.9, 0.9]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
  await subTestContext("diagonal runter, zwischen hohen", () => {
    setHeights(agt, [1.85, 1.8, 0.9, 1.85]);
    assertBestellisteContainsArtikelnummer(
      setArtikelnummer.dreifachtorSonderhöhe,
      agt.bestellliste
    );
  });
};

export const testEinfachtorMitNachbarelementKeineSonderhöhe: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4]);
  agt.update3d();
  const segment = agt.segmente[0];
  const profil = agt.createElementFromJson({
    füllungAuswahlwert: "DWPC Sand/Silber_easy",
  });
  segment.getEmpties()[0].fillWithElements(profil);
  agt.update3d();
  agt.auswahlAccessoren.Pfostenfarbe.setter(APP.richMetadata.findAuswahlwert("Silber"));
  const tor = segment.getElemente()[1];
  agt.setSelectedObjects([tor]);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    schaffePlatzFallsDoppeltor: false,
  });
  agt.update3d();
  assert.isFalse(
    tor.pfostenLinks.bestellliste.map((b) => b.ArtikelID).includes("2623_silber"),
    "2623_silber (Torpfosten-Set z. Einbetonieren für Einzeltor Sonderhöhe) darf nicht enthalten sein"
  );
  assert.isTrue(
    tor.pfostenLinks.bestellliste.map((b) => b.ArtikelID).includes("2099"),
    "korrekter Torpfosten ist 2099"
  );
  const element = segment.getElemente()[0];
  element.uiRemove();
  agt.update3d();
  assert.isFalse(
    tor.pfostenLinks.bestellliste.map((b) => b.ArtikelID).includes("2623_silber"),
    "2623_silber (Torpfosten-Set z. Einbetonieren für Einzeltor Sonderhöhe) darf nicht enthalten sein"
  );
  assert.isTrue(
    tor.pfostenLinks.bestellliste.map((b) => b.ArtikelID).includes("2099"),
    "korrekter Torpfosten ist 2099"
  );
};

function setHeights(agt: Arrangement, heights: number[]) {
  const segment = agt.segmente[0];
  segment
    .getElemente()
    .filter((_, i) => i < heights.length)
    .forEach((e, i) => e.setKonfigurierbareHöhe(heights[i]));
  agt.update3d();
}

async function createElementEinzeltorElementArrangement() {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [6]);
  agt.update3d();
  const segment = agt.segmente[0];
  const profil = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Teak-Braun",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  segment.getEmpties()[0].fillWithElements(profil);
  agt.update3d();
  const tor = segment.getElemente()[1];
  tor.anschlagAuswahlwert = APP.richMetadata.findAuswahlwert("Anschlag_links");
  APP.arrangement.setSelectedObjects(tor);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  return { agt, segment, tor };
}

async function createElementDoppeltorElementArrangement() {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.update3d();
  const segment = agt.segmente[0];
  const profil = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Teak-Braun",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  segment.getEmpties()[0].fillWithElements(profil);
  agt.update3d();
  const tor = segment.getElemente()[2];
  APP.arrangement.setSelectedObjects(tor);
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  APP.arrangement.setSelectedObjects(segment.getElemente()[0]);
  await APP.arrangement.removeSelectedObjects();
  agt.update3d();
  return { agt, segment, tor };
}

async function createElementDreifachtorElementArrangement() {
  resetArrangement(true);
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.update3d();
  const segment = agt.segmente[0];
  const profil = agt.createElementFromJson({
    füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Teak-Braun",
    abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
  });
  segment.getEmpties()[0].fillWithElements(profil);
  agt.update3d();
  const tor = segment.getElemente()[2];
  APP.arrangement.setSelectedObjects(tor);
  const doppelAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert: doppelAuswahlwert });
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const tor2 = segment.getElemente()[1];
  tor2.anschlagAuswahlwert = APP.richMetadata.findAuswahlwert("Anschlag_rechts");
  APP.arrangement.setSelectedObjects(tor2);
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  return { agt, segment, tor, tor2 };
}

export const testTorpfostenSonderhöheAnMauer: Test = async () => {
  const agt = resetArrangement(true);
  const json = {
    inspiration: "Inspiration SYSTEM GLAS Klar",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -2.46,
            y: 0,
          },
        },
        {
          id: 4,
          punkt: {
            x: 2.46,
            y: 0,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 4],
        },
      ],
    },
    segmente: [
      {
        breite: 4.92,
        partsAndPfosten: [
          {
            type: "Pfosten",
            x0: 3.75,
            pfostenfarbeAuswahlwert: "Silber",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwert: "Elementhalter Weiß",
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Torpfosten Einbetonieren Silber",
          },
          {
            type: "Element",
            breite: 1.05,
            höhe: 1.8,
            snap: 1,
            isBreiteKonfigurierbar: true,
            x0: 3.8425,
            füllungAuswahlwert: "SYSTEM GLAS Klar",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            rahmenAuswahlwert: "Tor_Rahmen_Silber",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_rechts",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            abschlussleisteAuswahlwertIndividualisiert: false,
            eAntriebAuswahlwert: "E_Antrieb_ohne",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Einzeltor",
            massAuswahlwert: "Einzeltor_Easy",
            profilPosition: null,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: true,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM GLAS",
            anMauer: "AnMauer_rechts",
            isMasstor: true,
            isMasselement: false,
            isMassProfil: false,
            isEAntrieb: false,
            key: "4460 SYSTEM GLAS Mass Einzeltor Klar",
            lichteWeite: 1.09,
            einsteckschlossAuswahlwert: "Einsteckschloss_inklusive",
            beschlagsatzAuswahlwert: "Beschlagsatz_inklusive",
            hideRahmen: false,
            showProfilausrichtung: false,
            showAdapterleiste: false,
            hasAnschlagprofil: true,
            bestelllisteArtikel: ["4460", "E1081", "611", "1251", "2550"],
            artikelID: "4460",
            füllungName: "Füllung",
            pdf: {},
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 4.905,
            pfostenfarbeAuswahlwert: "Silber",
            anschlagprofilfarbeAuswahlwert: "211_Montageplatten verzinkt",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Metalltorpfosten",
            montageadapterAuswahlwert: "Montageadapter_ohne",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            ankerInnen: false,
            ausgleichGefälle: false,
            pfostenAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -2.46,
          y: 0,
          z: 0,
        },
      },
      {
        position: {
          x: 2.46,
          y: 0,
          z: 0,
        },
      },
    ],
    aufbauten: [
      {
        Key: "3jse66aftes2",
        aufbauMeta: "Mauer",
        position: {
          x: 2.9614635230127497,
          y: 0,
          z: 0.000043851940620953656,
        },
        size: {
          x: 1.001973189278654,
          y: 2,
          z: 1.0020496671253023,
        },
        drehung: 0,
      },
    ],
    lichtleistenSplitter: 0,
    pfostenartAuswahlwert: "Metalltorpfosten",
    pfostenfarbeAuswahlwert: "Silber",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "StandardLinks",
  };
  agt.fromJSON(json);
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "4460",
        Anzahl: 1,
        Mass: "105 x 180 cm",
      },
      {
        ArtikelID: "E1081",
        Anzahl: 1,
      },
      {
        ArtikelID: "611",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
  agt.getTore()[0].höhe = 1.2;
  agt.update3d();
  assertEqualsBestellliste(
    [
      {
        ArtikelID: "4460",
        Anzahl: 1,
        Mass: "105 x 120 cm",
      },
      {
        ArtikelID: "2623_silber",
        Anzahl: 1,
      },
      {
        ArtikelID: "611",
        Anzahl: 1,
      },
      {
        ArtikelID: "1251",
        Anzahl: 1,
      },
      {
        ArtikelID: "2550",
        Anzahl: 1,
      },
    ],
    agt.bestellliste
  );
};
